/** Paths that must boot from anonymous `/public/*` config only (no `/my/*` settings or strings). */
const PUBLIC_AUTH_PATH_RE = /(?:^|\/)(login|logout|error)(?:\/|$)/;

/**
 * True on the internal login, logout, and error surfaces.
 * Those pages must not fetch authenticated settings or strings.
 */
export function isPublicAuthPath(pathname = typeof window !== 'undefined' ? window.location.pathname : ''): boolean {
  return PUBLIC_AUTH_PATH_RE.test(pathname);
}
